// ComInfoDict.js
// DbdbTap 2024-09-02 11:51:15
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

/*

	운송사코드
	운송사
	업종 p_bill_job_type
	업종 분류 p_bill_job_class
	운송사 별칭 p_com_alias
	대표자명 p_repr_name
	전화번호 p_office_tel
	FAX p_fax_tel
	우편번호 (주소검색) p_zip_cd
	주소 p_addr
	[담당자 정보]
	담당자 p_agent_name
	연락처 p_agent_tel_no
	이메일 p_agent_email

*/

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    comId : {
		id: 'comId', label: '운송사코드',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
	},
    comName : {
		id: 'comName', label: '운송사',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 1, 30)},
	},
    comAlias : {
		id: 'comAlias', label: '운송사 별칭',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 1, 30)},
	},
    billJobType : {
		id: 'billJobType', label: '업종',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	},
    billJobClass : {
		id: 'billJobClass', label: '업종 분류',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	},
    reprName : {
		id: 'reprName', label: '대표자명',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	},
    officeTel : {
		id: 'officeTel', label: '전화번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    faxTel : {
		id: 'faxTel', label: 'FAX',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    zipCd : {
		id: 'zipCd', label: '우편번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	},
    addr : {
		id: 'addr', label: '주소',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '100자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 100)},
	},
    agentName : {
		id: 'agentName', label: '담당자',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	},
    agentEmail : {
		id: 'agentEmail', label: '이메일',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '256자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 256)},
	},
    agentTelNo : {
		id: 'agentTelNo', label: '연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	},
    /* dcCd : {
		id: 'dcCd', label: 'dcCd',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	},
    compBizNo : {
		id: 'compBizNo', label: 'compBizNo',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	},
    compCorpNo : {
		id: 'compCorpNo', label: 'compCorpNo',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '13자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 13)},
	},
    cvoCustId : {
		id: 'cvoCustId', label: 'cvoCustId',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	},
    mapUserId : {
		id: 'mapUserId', label: 'mapUserId',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	},
    mapPassword : {
		id: 'mapPassword', label: 'mapPassword',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	},
    useYn : {
		id: 'useYn', label: '사용여부',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, */
    
};

/**
 * COM_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-09-02 11:51:15 using DbdbTap
 */
export const ComInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '운송사 등록 오류',
        Edit: '운송사 정보 수정 오류',
        Remove: '운송사 정보 삭제 오류',
        Get: '운송사 조회 오류',
    },
    tableProps: {
        tableId: 'comInfoTable',
        uniqueKey: 'comId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'dcName', label: '출발지', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: '운송사', width: 160, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comAlias', label: '운송사별칭', width: 160, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comId', label: Dict.comId.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //{ id: 'compBizNo', label: Dict.compBizNo.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'compCorpNo', label: Dict.compCorpNo.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'zipCd', label: '우편번호', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'addr', label: '주소', width: 260, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'officeTel', label: '운송사 전화번호', width: 120, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'reprName', label: '대표자', width: 60, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'faxTel', label: Dict.faxTel.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'billJobType', label: Dict.billJobType.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'billJobClass', label: Dict.billJobClass.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'agentName', label: '담당자', width: 60, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'agentEmail', label: '담당자메일', width: 200, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'agentTelNo', label: '담당자전화', width: 120, show: true, privacy:true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: '사용여부', width: 70, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            { id: 'regDate', label: "등록일", width: 100, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'regUserName', label: "등록자", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            
        ]
    },
    freeTableProps: {
        // 운송사	전화번호	대표자명	업종구분	등록일	등록자
        tableId: 'comInfoTableFree',
        uniqueKey: 'comId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: true,
            hideColumnConfig: true,
            growToFill: true,
            hideBubble: true,
        },
        columns: [
            { id: 'comName', label: '운송사', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'officeTel', label: '운송사 전화번호', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'reprName', label: '대표자', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'billJobType', label: '업종구분', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 100, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'regUserName', label: "등록자", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    comListWithOwnedVehCountProps: {
        tableId: 'comInfoTableWithVehCount',
        uniqueKey: 'comId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            hideBubble: false,
        },
        columns: [
            { id: 'dcTypeName', label: 'DC타입', width: 60, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: '소속센터', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comId', label: '운송사코드', width: 110, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'comName', label: '운송사', width: 140, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'countVehicle', label: '차량수', width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
        ]
    }
};
